import type { FontAwesomeBrandIcon, FontAwesomeBrandTheme, FontAwesomeIcon, FontAwesomeTheme } from '@/shared/components/ui/icon/fa.types';

import { FA, type FontAwesomeIconProps } from '@/shared/components/ui/icon/FA';

interface Props extends Omit<FontAwesomeIconProps, 'theme' | 'icon'> {
  theme?: FontAwesomeBrandTheme;
  icon: FontAwesomeBrandIcon;
}

/**
 * FontAwesome Brand Icons (FAB)
 * @see https://fontawesome.com/icons/packs/brands
 */
export const FB = ({ theme = 'fab', icon, ...props }: Props) => (
  <FA theme={theme as FontAwesomeTheme} icon={icon as FontAwesomeIcon} {...props} />
);
